import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { store } from '../../store/store';
import { clearMedia } from '../../store/slices/mediaSlice';
import { clearRoom, setLocalParticipantStatus } from '../../store/slices/roomSlice';

const stopMeetingMedia = () => {
  try {
    const localStream = store.getState()?.media?.localStream;
    localStream?.getTracks?.().forEach((track) => track.stop());
  } catch {
    // Ignore tracks already stopped.
  }

  try {
    window.mediaSoupHandler?.destroy?.();
    window.mediaSoupHandler = null;
  } catch {
    // Ignore handler cleanup errors.
  }

  document.querySelectorAll('video, audio').forEach((element) => {
    try {
      element.srcObject?.getTracks?.().forEach((track) => track.stop());
      element.srcObject = null;
    } catch {
      // Ignore media element cleanup errors.
    }
  });
};

const clearRoomLocks = (roomId) => {
  try {
    Object.keys(localStorage)
      .filter((key) => key.startsWith(`meet-lock:${roomId}:`))
      .forEach((key) => localStorage.removeItem(key));
  } catch {
    // Ignore browser storage cleanup errors.
  }
};

const LeftMeeting = () => {
  const navigate = useNavigate();
  const { roomId } = useParams();

  useEffect(() => {
    stopMeetingMedia();
    clearRoomLocks(roomId);
    store.dispatch(clearMedia());
    store.dispatch(clearRoom());
    store.dispatch(setLocalParticipantStatus(null));
  }, [roomId]);

  const rejoin = () => {
    sessionStorage.removeItem('meetingEnd');
    sessionStorage.removeItem('rejoin-room');
    sessionStorage.setItem('rejoinStatus', 'true');
    sessionStorage.setItem('lastRoomId', roomId);
    navigate(`/rejoin/${encodeURIComponent(roomId)}`);
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-white px-6 text-center">
      <section className="w-full max-w-lg">
        <h1 className="text-3xl font-semibold text-slate-800">
          You&apos;ve left the meeting
        </h1>

        <div className="mt-7 flex flex-wrap justify-center gap-3">
          <button
            type="button"
            onClick={rejoin}
            className="rounded-lg border border-blue-600 px-6 py-2.5 font-semibold text-blue-600 transition hover:bg-blue-50"
          >
            Rejoin
          </button>

          <button
            type="button"
            onClick={() => navigate('/', { replace: true })}
            className="rounded-lg bg-blue-600 px-6 py-2.5 font-semibold text-white transition hover:bg-blue-700"
          >
            Return to home screen
          </button>
        </div>

        <div className="mx-auto mt-10 max-w-sm rounded-xl border border-slate-200 p-5">
          <p className="font-semibold text-slate-700">Your meeting is safe</p>
          <p className="mt-2 text-sm leading-6 text-slate-500">
            Rejoining restores the same authenticated session. Waiting-room
            participants still require admission from an authorised moderator.
          </p>
        </div>
      </section>
    </main>
  );
};

export default LeftMeeting;
